import { Message } from 'element-ui'

/**
 * 判断是否是对象
 * @param {any} value 要判断的变量，可能是任意类型
 * @returns result 判断的结果，是对象则为true，不是则为false
 */
export function isObject(value) {
  return Object.prototype.toString.call(value) === '[object Object]'
}

/**
 * 判断是否是数组
 * @param {any} value 要判断的变量，可能是任意类型
 * @returns result 判断的结果，是数组则为true，不是则为false
 */
export function isArray(value) {
  return Object.prototype.toString.call(value) === '[object Array]'
}

/**
 * 判断是否是字符串
 * @param {any} value 要判断的变量，可能是任意类型
 * @returns result 判断的结果，是字符串则为true，不是则为false
 */
export function isString(value) {
  return Object.prototype.toString.call(value) === '[object String]'
}

/**
 * 判断是否是数值
 * @param {any} value 要判断的变量，可能是任意类型
 * @returns result 判断的结果，是数值则为true，不是则为false
 */
export function isNumber(value) {
  return (
    Object.prototype.toString.call(value) === '[object Number]' && !isNaN(value)
  )
}

/**
 * 判断是否是空对象
 * @param {Object} obj 对象
 */
export function isEmptyObject(obj) {
  if (isObject(obj) && JSON.stringify(obj) === '{}') {
    Message.error('对象信息为空')
  }
}

/**
 * 判断数组是否为空
 * @param {Array} arr 数组
 */
export function isEmptyArray(arr) {
  if (isArray(arr) && arr.length === 0) {
    Message.error('数组信息为空')
  }
}
